import { history } from 'redux/lib/configureStore.js';
import queryMap from './constants/queryMap.js';

const stripArtifacts = (n) => String(n || '').replace(/(\?|&)/g, '');

export const setQuery = (newValues = {}, useCurrentValues = true) => {
  const nv = Object.fromEntries(Object.entries(newValues).map((n) => [queryMap[n[0]] || n[0], n[1]]));
  const currentValues = Object.fromEntries(new URLSearchParams(window.location.search));
  const mergedValues = useCurrentValues ? { ...currentValues, ...nv } : { ...nv };
  const entries = Object.entries(mergedValues)
    .map((n) => [stripArtifacts(n[0]), n[1]])
    .filter((n) => n[1] !== null && n[1] !== undefined)
    .map((n) => [queryMap[n[0]] || n[0], n[1]]);
  const params = new URLSearchParams(Object.fromEntries(entries)).toString();
  const url = `${window.location.pathname}?${params}`;
  history.push(url);
};

export default setQuery;
